import { TenantChildNode } from '@fluentsms/graphql';
import { useMemo } from 'react';
import { DrawerAutocompleteOptions, DrawerOptions } from '../base';
import { convertToDrawerOption } from './common';

export const useCompanyAutocomplete = (
  companies: TenantChildNode[],
  selectedCompanyId: string,
): DrawerAutocompleteOptions => {
  const options = useMemo(
    () => [
      ...companies.map(convertToDrawerOption(selectedCompanyId)),
      {
        itemId: '',
        name: '',
        selected: !selectedCompanyId,
      },
    ],
    [companies, selectedCompanyId],
  );

  const selectedOption = useMemo(
    () =>
      options.find((option: DrawerOptions) => option.selected) ?? {
        itemId: '',
        name: '',
        selected: true,
      },
    [options],
  );
  return {
    options,
    selectedOption,
  };
};
